var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "messenger-page-selector" }, [
    _c("div", { staticClass: "page-card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "page-card-body" }, [
        _c(
          "div",
          { staticClass: "page-card-body-content" },
          _vm._l(_vm.getMessengerPages(), function (page) {
            return _c(
              "div",
              { key: page.id, staticClass: "page-card-body-content-item" },
              [
                _c(
                  "div",
                  { staticClass: "page-card-body-content-item-image" },
                  [
                    _c("img", {
                      attrs: { src: page.picture.data.url, alt: "page image" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "page-card-body-content-item-info" }, [
                  _c(
                    "div",
                    { staticClass: "page-card-body-content-item-info-name" },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(page.name) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-card-body-content-item-info-username",
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(page.username) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-card-body-content-item-action" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function () {
                            return _vm.changeValue(page)
                          },
                        },
                      },
                      [_vm._v(" Select")]
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-card-header" }, [
      _c("div", { staticClass: "page-card-header-title" }, [
        _vm._v("Select a Messenger Account"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }